import { brandConfiguration } from "@/brands/config";
import { IS_SERVER } from "@/constants";
// We specify a prefix to avoid mixing feature enabled with other possible query params
const FEATURE_ENABLED_PREFIX = "feature_";
/**
 * This function will filter the URL query params that start with the _feature prefix
 *
 * example: "www.immonet.de/expose/xxx?feature_georisk=true"
 * will return { georisk: true }
 */
export const getFeaturesEnabledFromQuery = (query) => {
    const searchParams = new URLSearchParams(query);
    const result = {};
    searchParams.forEach((value, key) => {
        if (key.startsWith(FEATURE_ENABLED_PREFIX) &&
            (value === "true" || value === "false")) {
            result[key.replace(FEATURE_ENABLED_PREFIX, "")] = value === "true";
        }
    });
    return result;
};
/**
 * This function will be executed at the Request time
 * The FeatureEnabled object from Brand configuration is merged/overrode with query params from the URL provided with the Prefix
 *
 * example: "www.immonet.de/expose/xxx?feature_georisk=true" will force-enable the georisk feature even if it's set to false in the Brand configuration
 *
 * @param query - the query string from the URL
 *
 * @returns the FeaturesEnabled object with the query params merged
 *
 */
export const getFeaturesEnabled = () => {
    var _a;
    if (IS_SERVER)
        return brandConfiguration.featuresEnabled;
    // eslint-disable-next-line no-restricted-globals
    const query = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) || "";
    const featuresEnabledFromQuery = getFeaturesEnabledFromQuery(query);
    return Object.assign(Object.assign({}, brandConfiguration.featuresEnabled), featuresEnabledFromQuery);
};
